import type { VerificationChecklistItem } from '@chukua/common';
import { Input, Radio } from 'antd';
import { CHECKLIST_LABELS, type VerificationFormValues } from '../policies/verification-form.policy';

interface VerificationCheckRowProps {
  item: VerificationChecklistItem;
  answer: VerificationFormValues[VerificationChecklistItem];
  disabled: boolean;
  onChange: (answer: VerificationFormValues[VerificationChecklistItem]) => void;
}

/** One of the four checks: pass or fail, and an optional note. */
export function VerificationCheckRow({ item, answer, disabled, onChange }: VerificationCheckRowProps) {
  return (
    <div className="flex flex-col gap-2">
      <span id={`check-${item}`} className="font-medium">
        {CHECKLIST_LABELS[item]}
      </span>
      <Radio.Group
        aria-labelledby={`check-${item}`}
        value={answer.result}
        disabled={disabled}
        onChange={(event) => onChange({ ...answer, result: event.target.value })}
      >
        <Radio value="pass">Pass</Radio>
        <Radio value="fail">Fail</Radio>
      </Radio.Group>
      <Input
        aria-label={`Note on: ${CHECKLIST_LABELS[item]}`}
        placeholder="Note (optional)"
        maxLength={500}
        value={answer.note}
        disabled={disabled}
        onChange={(event) => onChange({ ...answer, note: event.target.value })}
      />
    </div>
  );
}
